import { render, staticRenderFns } from "./Cotizacion.vue?vue&type=template&id=48ffe466&"
import script from "./Cotizacion.vue?vue&type=script&lang=js&"
export * from "./Cotizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports